import MeaDetailField from "../../../../components/MeaDetailField";
import MeaDetailCard from "../../../../components/MeaDetailCard";
import { CalculateAge } from "../../../../utils/dates";
import { Tag } from "primereact/tag";

const MemberDetailComponent = ({ member }) => {
  return (
    <MeaDetailCard>
      <MeaDetailField field="Nom" value={member?.lastname || "-"} />
      <MeaDetailField field="Prénom" value={member?.firstname || "-"} />
      <MeaDetailField field="Nom d'usage" value={member?.name || "-"} />
      <MeaDetailField
        field="Genre"
        value={
          member?.gender !== undefined && member?.gender === "G"
            ? "Féminin"
            : member?.gender === "B"
              ? "Masculin"
              : "-"
        }
      />
      <MeaDetailField
        field="Date de naissance"
        value={
          member?.birthday !== undefined && member?.birthday !== null && member?.birthday !== ""
            ? member?.birthday +
            " (" +
            CalculateAge(member?.birthday) +
            " ans)"
            : "-"
        }
      />
      <MeaDetailField
        field="Role"
        value={
          <div className="flex flex-wrap justify-content-start gap-1">
            {member?.is_owner && (
              <Tag value="Propriétaire" severity="info" rounded></Tag>
            )}
            {member?.is_admin && (
              <Tag value="Administration" severity="info" rounded></Tag>
            )}
            {member?.is_staff && (
              <Tag value="Secrétariat" severity="info" rounded></Tag>
            )}
            {member?.is_teacher && (
              <Tag value="Enseignant(e)" severity="info" rounded></Tag>
            )}
            {member?.is_parent && (
              <Tag value="Parent" severity="info" rounded></Tag>
            )}
            {member?.is_student && (
              <Tag value="Elève" severity="info" rounded></Tag>
            )}
          </div>
        }
      />
    </MeaDetailCard>
  );
};

export default MemberDetailComponent;
